var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-footer",
    { staticStyle: { height: "872px" } },
    [
      _c(
        "el-container",
        { staticClass: "d-flex-column" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-menu",
                    {
                      staticClass: "el-menu-demo",
                      attrs: {
                        router: true,
                        "default-active": _vm.activeLink,
                        mode: "vertical"
                      },
                      on: { open: _vm.handleSelect }
                    },
                    [
                      _vm._l(_vm.footerList, function(footermenu, index) {
                        return _vm.currentLanguage == "en"
                          ? [
                              _c(
                                "el-menu-item",
                                {
                                  key: index,
                                  attrs: { index: footermenu.path }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(footermenu.footermenuname) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      }),
                      _vm._l(_vm.footerArList, function(footermenu, index) {
                        return _vm.currentLanguage == "ar"
                          ? [
                              _c(
                                "el-menu-item",
                                {
                                  key: index,
                                  attrs: { index: footermenu.path }
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(footermenu.footermenuname) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c("el-col", { staticClass: "text-right", attrs: { span: 18 } }, [
                _c(
                  "a",
                  {
                    staticClass: "footer-brand",
                    attrs: { href: "javascript:void(0);" },
                    on: {
                      click: function($event) {
                        _vm.$router.push("/")
                      }
                    }
                  },
                  [
                    _c("img", {
                      staticClass: "logo",
                      attrs: {
                        alt: "Maren Logo",
                        src: require("../../../public/img/logo.svg"),
                        width: "220"
                      }
                    })
                  ]
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "footer-bar" },
            [
              _c(
                "el-row",
                { attrs: { gutter: 24 } },
                [
                  _c("el-col", { attrs: { span: 16 } }, [
                    _c("ul", { staticClass: "footer-list" }, [
                      _c("li", { staticClass: "footer-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "footer-link",
                            attrs: { href: "javascript:void();" }
                          },
                          [
                            _vm._v(
                              "© " +
                                _vm._s(new Date().getFullYear()) +
                                " Maren Solutions"
                            )
                          ]
                        )
                      ]),
                      _c("li", { staticClass: "footer-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "footer-link",
                            attrs: { href: "javascript:void();" }
                          },
                          [_vm._v("Privacy Policy")]
                        )
                      ]),
                      _c("li", { staticClass: "footer-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "footer-link",
                            attrs: { href: "javascript:void();" }
                          },
                          [_vm._v("Cookie Policy")]
                        )
                      ]),
                      _c("li", { staticClass: "footer-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "footer-link",
                            attrs: { href: "javascript:void();" }
                          },
                          [_vm._v("Terms & Conditions")]
                        )
                      ])
                    ])
                  ]),
                  _c("el-col", { staticClass: "social", attrs: { span: 8 } }, [
                    _c(
                      "a",
                      {
                        staticClass: "linkedIn",
                        attrs: {
                          rel: "nofollow",
                          "data-tracker": "LINKEDIN",
                          target: "_blank",
                          href: ""
                        }
                      },
                      [_c("i", { staticClass: "icon-linkedin" })]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "facebook",
                        attrs: {
                          rel: "nofollow",
                          "data-tracker": "FACEBOOK",
                          target: "_blank",
                          href: ""
                        }
                      },
                      [_c("i", { staticClass: "icon-facebook" })]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "twitter",
                        attrs: {
                          rel: "nofollow",
                          "data-tracker": "TWITTER",
                          target: "_blank",
                          href: ""
                        }
                      },
                      [_c("i", { staticClass: "icon-twitter" })]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "instagram",
                        attrs: {
                          rel: "nofollow",
                          "data-tracker": "INSTAGRAM",
                          target: "_blank",
                          href: ""
                        }
                      },
                      [_c("i", { staticClass: "icon-instagram" })]
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/common/Footer.vue?vue&type=template&id=041e3202&
// module id = 351
// module chunks = 10